"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.log = void 0;
const log = (objects) => {
    objects.forEach((loggable) => {
        console.log(`${loggable.label}:`, loggable.content);
    });
};
exports.log = log;
